module.exports = __webpack_public_path__ + "static/media/43.07cd9f59.jpg";